/**
 * @Description GDP及增速情况
 */

import { FC, useMemo } from 'react';
import styles from '../index.module.less';
import V2BarLineChart from '@/common/components/Charts/V2BarLineChart';
import { isUndef } from '@lhb/func';
import { Typography } from 'antd';
import React from 'react';

interface GDPModelProps {
  data: any;
  name: string;
}

const GDPModel: FC<GDPModelProps> = React.memo(({ data, name }) => {

  const { years, gdps, gdpGrowthRates, title } = useMemo(() => {
    const years: any[] = [];
    const gdps: any[] = [];
    const gdpGrowthRates: any[] = [];
    let title: string = '';
    let startYear = '';
    let endYear = '';

    if (!data?.dataResponseList) { return { years, gdps, gdpGrowthRates, title, }; }

    data?.dataResponseList?.map((item, index) => {
      if (index === 0)startYear = item.year;
      if (index === data?.dataResponseList.length - 1) endYear = item.year;

      years.push(item.year);
      gdps.push(isUndef(item.gdp) ? '' : item.gdp);
      gdpGrowthRates.push(isUndef(item.gdpGrowthRate) ? '' : item.gdpGrowthRate);
    });

    title = `${startYear || ''}-${endYear || ''}${name || ''}GDP及增速情况`;

    return {
      years,
      gdps,
      gdpGrowthRates,
      title,
    };
  }, [data?.dataResponseList, name]);

  return (
    <div className={styles['module']}>
      {title
        ? <div className={styles.moduleChartWrap}>
          <div className={styles.moduleChartTitle}>
            <Typography.Text
              style={{ width: '100%' }}
              ellipsis={{ tooltip: title }}
            >
              {title}
            </Typography.Text>
          </div>
          <V2BarLineChart
            border
            title=''
            xAxisData={years}
            seriesData={[{
              name: 'GDP',
              type: 'bar',
              yAxisIndex: 0,
              data: gdps,
              unit: '亿元'
            }, {
              name: '同比增长',
              type: 'line',
              unit: '%',
              yAxisIndex: 1,
              data: gdpGrowthRates,
            }]}
            yAxisData={[
              {},
              { axisLabel: { formatter: '{value}%' } }
            ]}
            config={{
              legend: {
                bottom: 4,
                top: 'auto',
                left: 'center',
                right: 'center',
                width: '100%',
              },
              grid: {
                bottom: 56,
              }
            }}
          />
        </div>
        : <></>}
    </div>
  );
});

export default GDPModel;
